import { Entry } from '../Entry'

export function Entry20250212() {
  return (
    <Entry title="2025 Feb 12 - v3.10.2">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/16233/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
